import { render, staticRenderFns } from "./relocate_with_tag.vue?vue&type=template&id=6381f880"
import script from "./relocate_with_tag.vue?vue&type=script&lang=js"
export * from "./relocate_with_tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports